export const FormatDate = {
    methods: {
        formatDate(date1, date2) {
            let options = { year: "numeric", month: "short", day: "numeric" };
            let localelang = "";

            if (this.$page.props.locale == "de") {
                localelang = "de-DE";
            } else if (this.$page.props.locale == "fr") {
                localelang = "fr-FR";
            } else {
                localelang = "en-GB";
            }

            if (isNaN(new Date(date1))) {
                return "-";
            }

            let expecteddate = new Date(date1).toLocaleDateString(
                localelang, options
            );
            if (date2) {
                var timeleft = date2 - date1;
                var days = Math.ceil((((timeleft / 1000) / 60) / 60) / 24);

                if (isNaN(days)) {
                    return "-";
                }
        
                return " (" + expecteddate + " : " + days + " Days Delay" + ")";
            }
            else {
                return expecteddate;
            }
        },
        dateTime(date) {
            let options = { year: "numeric", month: "short", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric'};
            let localelang = "";

            if (this.$page.props.locale == "de") {
                localelang = "de-DE";
            } else if (this.$page.props.locale == "fr") {
                localelang = "fr-FR";
            } else {
                localelang = "en-GB";
            }
            var thedate = new Date(date);
            return thedate.toLocaleString('en-GB', { hour12: false })
        }
    }
};
